import api from './api';
import type {
  Workflow,
  WorkflowListItem,
} from '../types/workflow';

const API_BASE = '/workflows';

// 获取工作流列表
export const getWorkflows = async (): Promise<WorkflowListItem[]> => {
  const response = await api.get<{ data: WorkflowListItem[]; meta?: unknown }>(API_BASE);
  // 后端返回格式: { data: [...], meta: {...} }
  if (response.data && Array.isArray(response.data.data)) {
    return response.data.data;
  }
  throw new Error('获取工作流列表失败: 响应格式错误');
};

// 获取单个工作流
export const getWorkflow = async (id: string): Promise<Workflow> => {
  const response = await api.get<Workflow>(`${API_BASE}/${id}`);
  if (response.data) {
    return response.data;
  }
  throw new Error('获取工作流失败: 响应格式错误');
};

// 创建工作流
export const createWorkflow = async (
  workflow: Omit<Workflow, 'id' | 'createdAt' | 'updatedAt'>
): Promise<Workflow> => {
  const response = await api.post<Workflow>(API_BASE, workflow);
  if (response.data) {
    return response.data;
  }
  throw new Error('创建工作流失败: 响应格式错误');
};

// 更新工作流
export const updateWorkflow = async (
  id: string,
  updates: Partial<Workflow>
): Promise<Workflow> => {
  const response = await api.put<Workflow>(
    `${API_BASE}/${id}`,
    updates
  );
  if (response.data) {
    return response.data;
  }
  throw new Error('更新工作流失败: 响应格式错误');
};

// 删除工作流
export const deleteWorkflow = async (id: string): Promise<void> => {
  await api.delete(`${API_BASE}/${id}`);
};

// 执行工作流
export const executeWorkflow = async (
  id: string,
  variables?: Record<string, unknown>
): Promise<{ executionId: string }> => {
  const response = await api.post<{ executionId: string }>(
    `${API_BASE}/${id}/execute`,
    { variables }
  );
  if (response.data) {
    return response.data;
  }
  throw new Error('执行工作流失败: 响应格式错误');
};

// 获取工作流执行状态
export const getWorkflowExecution = async (executionId: string) => {
  const response = await api.get<unknown>(
    `${API_BASE}/executions/${executionId}`
  );
  if (response.data) {
    return response.data;
  }
  throw new Error('获取执行状态失败: 响应格式错误');
};
